module.exports = __webpack_public_path__ + "static/Qlik_dashboard_bureau_man-a9009262d779673731b7afa6133be496.jpg";